import React, { useEffect } from 'react'
import { initializeZoom } from '../utils/zoomSLD';

const SldContainer = ({children, siteType}) => {
     useEffect(() => {
    // const svgContainer = document.getElementById('SLD-Image');
    // const svg = svgContainer.querySelector('#genset-pvbess-sld');
    // const { zoomIn, zoomOut, resetTransform } = initializeZoom(svgContainer, svg);
    // document.getElementById('zoom-in').addEventListener('click', zoomIn);
    // document.getElementById('zoom-out').addEventListener('click', zoomOut);
    // document.getElementById('reset').addEventListener('click', resetTransform);
    // svgContainer.addEventListener('keydown', (e) => {
    //   if (e.key === '+' || e.key === '=') { zoomIn(); }
    //   else if (e.key === '-') { zoomOut(); }
    //   else if (e.key.toLowerCase() === 'r') { resetTransform(); }
    // });
    // svg.style.cursor = 'grab';
  }, [siteType]);
  return (
    <div
      id="SLD-Image"
      className="col-sm-12 col-md-12 col-lg-12 col-xl-12  px-0 sld-zoom-container"
       tabIndex="0" aria-label="SVG zoomable canvas"
       
    >
 {/* <div class="controls" aria-label="Zoom controls" style={{position: "absolute", top: "26px", right: "2px", zIndex:"10"}}>
  <button id="zoom-in" aria-label="Zoom in">➕ Zoom In</button>
  <button id="zoom-out" aria-label="Zoom out">➖ Zoom Out</button>
  <button id="reset" aria-label="Reset zoom and pan">⭯ Reset</button>
</div> */}
{children}
 </div>
  )
}

export default SldContainer